document.addEventListener('DOMContentLoaded', function() {

    const inputAbrirModal = document.querySelectorAll('.inputAbrirModal');
    const btnAbrirModal = document.querySelectorAll('.btnModal');

    //Abrir modal al hacer focus o click en input
    inputAbrirModal.forEach(function (inputModal) {
        function abrirModal() {
            var idModal = inputModal.getAttribute('data-modal');
            if (!idModal) return;
            var modal = document.querySelector('#' + idModal);
            if (!modal) return;
            modal.classList.add('modal--show');
        }
        inputModal.addEventListener('focus', abrirModal);
        inputModal.addEventListener('click', abrirModal);
    });
    //Abrir modal
    btnAbrirModal.forEach(btnModal => {
        btnModal.addEventListener('click',function(){
            const idBoton = (this.getAttribute('data-modal'))
            const modal = document.querySelector(`#${idBoton}`);
            modal.classList.add('modal--show');
        });
    });


});
